<div class="keen-slider__container">
  <div class="keen-slider__title-container">
    @if (title) {
    <h2 class="keen-slider__title">{{ title }}</h2>
    } @if (subtitle) {
    <div class="keen-slider__subtitle" [innerHTML]="subtitle"></div>
    }
  </div>
  <ul class="keen-slider__navigation list-unstyled">
    @for (item of parsedData; track item) {
    <li>
      <button
        class="pointer"
        tabindex="0"
        role="button"
        [ngClass]="{'active': $index === currentSlide() }"
        (click)="slider?.moveToIdx($index)"
        (keypress)="slider?.moveToIdx($index)"
      >
        {{ item.header_text }}
      </button>
    </li>
    }
  </ul>
  <div #sliderRef class="keen-slider keen-slider--vertical" [ngClass]="{'mono-slide': parsedData.length === 1}">
    @for (item of parsedData; track item) {
    <div class="keen-slider__slide">
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <div class="keen-slider__slide-title-container" [ngStyle]="{height: titleHeight() }">
        <h3 [class]="'keen-slider__slide-title slide__title-' + uniqueId ">{{ item.header_text }}</h3>
      </div>
      <div
        class="keen-slider__image"
        tabindex="0"
        role="button"
        aria-label="Open video modal"
        (click)="item.youtube_iframe && showYoutubeIframe(item.youtube_iframe, item.youtube_iframe_url)"
        (keypress)="item.youtube_iframe && showYoutubeIframe(item.youtube_iframe, item.youtube_iframe_url)"
      >
        <div class="overlay" [ngClass]="{'show' : item.youtube_iframe}">
          <i class="fas fa-play play-icon"></i>
        </div>
        <picture>
          <source media="(max-width: 768px)" [srcset]="item.image_mobile ? item.image_mobile : item.image" />
          <source media="(min-width: 769px)" [srcset]="item.image" />
          <img [src]="item.image" [alt]="item.header_text" />
        </picture>
      </div>
      <div class="keen-slider__slide-content">
        @if (item.slide_text) {
        <div class="keen-slider__text" [innerHTML]="item.slide_text"></div>
        } @if (item.footer_text) {
        <div class="keen-slider__text-footer" [innerHTML]="item.footer_text"></div>
        }
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
        <div
          class="keen-slider__button-container d-flex flex-column align-items-center justify-content-center"
          [ngStyle]="{'padding-bottom': !item.button_link_2 ? linkHeight()+'px' : '0'}"
        >
          @if (item.button_text && item.button_link) {
          <a
            class="keen-slider__button btn btn-primary"
            [href]="getHref(item.button_link)"
            (click)="hybridGoToPage($event, item.button_link)"
          >
            <span>{{item.button_text}}</span>
          </a>
          } @if (item.button_text_2 && item.button_link_2) {
          <a
            class="keen-slider__button__link-more"
            [ngClass]="'keen-slider__button__link-' + uniqueId"
            [href]="getHref(item.button_link_2)"
            (click)="hybridGoToPage($event, item.button_link_2)"
          >
            <span>{{item.button_text_2}}</span>
          </a>
          }
        </div>
      </div>
    </div>
    }
    <div class="keen-slider__arrows">
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <div
        role="button"
        type="button"
        aria-label="previous"
        class="arrow arrow--left"
        tabindex="0"
        [ngStyle]="{top: arrowTop() + 'px'}"
        (click)="slider?.prev()"
        (keypress)="slider?.prev()"
      >
        <img alt="left arrow icon" [src]="'assets/images/arrow-left.svg' | staticFileHash" />
      </div>
      <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
      <div
        role="button"
        type="button"
        aria-label="next"
        class="arrow arrow--right"
        tabindex="0"
        [ngStyle]="{top: arrowTop() + 'px'}"
        (click)="slider?.next()"
        (keypress)="slider?.next()"
      >
        <img alt="rigth arrow icon" [src]="'assets/images/arrow-right.svg' | staticFileHash" />
      </div>
    </div>
  </div>
  @if (slider && parsedData.length > 1) {
  <div class="keen-slider__controls">
    <div class="keen-slider__dots">
      @for (slide of dotHelper; track slide) {
      <button
        type="button"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Go to slide' + $index"
        [class]="'dot ' + ($index === currentSlide() ? 'active' : '')"
        (click)="slider.moveToIdx($index)"
        (keypress)="slider.moveToIdx($index)"
      >
        <span class="sr-only">Slider step {{$index}}</span>
      </button>
      }
    </div>
  </div>
  } @if (button_link) {
  <div class="d-flex justify-content-center">
    <a class="keen-slider__button__link-more" [routerLink]="button_link">
      <span i18n="@@LEARN_MORE">Learn more</span>
    </a>
  </div>
  }
</div>

@if (modalOpen() || (!modalOpen() && delayedModalOpen())) {
<div @modalBackgroundAnimation class="backdrop custom-modal" (click)="modalClose()">
  <div class="modal-content">
    @if (delayedModalOpen() && modalOpen()) {
    <div @modalAnimation class="iframe-wrapper" (click)="$event.stopPropagation()">
      <iframe
        class="iframe-content"
        title="iframeYoutube"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        [src]="video_src"
      >
      </iframe>
    </div>
    }
  </div>
</div>
}
